module.exports = __webpack_public_path__ + "img/0k.7fd16323.svg";